var _rect, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 0,
    width: 38,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    width: 38,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 2.5C46.7826 2.5 55.685 6.18749 62.2487 12.7513C68.8125 19.315 72.5 28.2174 72.5 37.5C72.5 46.7826 68.8125 55.685 62.2487 62.2487C55.685 68.8125 46.7826 72.5 37.5 72.5",
    stroke: "white",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 72.5C28.2174 72.5 19.315 68.8125 12.7513 62.2487C6.18749 55.685 2.5 46.7826 2.5 37.5C2.50001 28.2174 6.1875 19.315 12.7513 12.7513C19.315 6.18748 28.2174 2.5 37.5 2.5",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24L50 51M50 24L37.5 37.5L25 51",
    stroke: "#F34141",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.00d3bbc79637f30e370fc1acc120c276.svg";
export { ForwardRef as ReactComponent };